module.exports = __webpack_public_path__ + "static/media/rebirth_18.49f1ddb6.jpg";